import { useDeleteRegistersDefinitionsMutation } from "../../../../redux/api/mod-bus/modBusAPI";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../../shared/oversight-core/utils/toast";

interface IProps extends ModelContainerProps {
  partitionKey: string;
  setIsUpdateCurrentState: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteSuccess?: () => void;
}

const DeleteConfigurationRegistersModal = (props: IProps) => {
  const { onClose, partitionKey, setIsUpdateCurrentState, onDeleteSuccess, ...rest } = props;

  const [deleteRegistersDefinitions, { isLoading }] =
    useDeleteRegistersDefinitionsMutation();

  const handleConfirm = () => {
    if (!partitionKey) return;

    deleteRegistersDefinitions({ partitionKey })
      .unwrap()
      .then(() => {
        showSuccessMessage("Configured registers deleted successfully");
        setIsUpdateCurrentState((ps) => !ps);
        onDeleteSuccess?.();
        onClose?.();
      })
      .catch(() => {
        showErrorMessage("Deleting configured registers unsuccessful");
      });
  };

  return (
    <ModalContainer
      {...rest}
      title="Delete Configured Registers"
      size="modal-md"
      confirmButtonText="Delete"
      confirmButtonVariant="red"
      onConfirm={handleConfirm}
      isLoading={isLoading}
    >
      <div className="font-size-14 text-dark font-weight-400">
        Are you sure you want to delete the configured registers for this
        device? This action cannot be undone.
      </div>
    </ModalContainer>
  );
};

export default DeleteConfigurationRegistersModal;
